import { render, staticRenderFns } from "./StepObject.vue?vue&type=template&id=ed10b69e"
import script from "./StepObject.vue?vue&type=script&lang=js"
export * from "./StepObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports